import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../../theme';

export const useMonitorFilterTemplatesStyles = createStyles(() => ({
  itemPopupLabel: {
    marginBottom: ThemeSpaces.SPACE_NORM0_5,
    '.label': {
      marginBottom: ThemeSpaces.SPACE_XXS,
    },
  },
  duplicateNameDialog: {
    '&.ant-modal': {
      '.ant-modal-body': {
        paddingBottom: ThemeSpaces.SPACE_NORM_30,
      },
      '.ant-row': {
        padding: `0 ${ThemeSpaces.SPACE_NORM_20}px`,
      },
    },
  },
}));
